import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../api';

const MESES = ['', 'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

export default function PeriodosPage() {
  const { cid } = useParams();
  const [rows, setRows] = useState([]);
  const [anio, setAnio] = useState(new Date().getFullYear());
  const [mes, setMes] = useState(new Date().getMonth() + 1);
  const [error, setError] = useState('');

  const load = () => {
    api
      .get(`/gastos-comunes/condominios/${cid}/periodos`)
      .then((r) => setRows(r.data))
      .catch((e) => setError(e.response?.data?.error || e.message));
  };

  useEffect(() => {
    if (cid) load();
  }, [cid]);

  const crear = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await api.post(`/gastos-comunes/condominios/${cid}/periodos`, { anio: Number(anio), mes: Number(mes) });
      load();
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    }
  };

  return (
    <>
      <div className="page-header">
        <h2>Períodos mensuales</h2>
        <p>Calendario de cobro. Simular y publicar cargos en la pantalla Cobros mensuales.</p>
      </div>
      {error && <div className="alert alert-error">{error}</div>}
      <div className="card">
        <form onSubmit={crear} className="form-row">
          <div className="field">
            <label>Año</label>
            <input type="number" value={anio} onChange={(e) => setAnio(e.target.value)} required />
          </div>
          <div className="field">
            <label>Mes</label>
            <select value={mes} onChange={(e) => setMes(Number(e.target.value))}>
              {MESES.slice(1).map((m, i) => (
                <option key={m} value={i + 1}>
                  {m}
                </option>
              ))}
            </select>
          </div>
          <button type="submit" className="btn">
            Crear período (borrador)
          </button>
        </form>
      </div>
      <div className="card">
        <div className="table-wrap">
          <table className="data-table">
            <thead>
              <tr>
                <th>Período</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((p) => (
                <tr key={p.id}>
                  <td>
                    {MESES[p.mes]} {p.anio}
                  </td>
                  <td>{p.estado}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
